import styled from 'styled-components'

const StyledView = styled.div`
  display: flex;
  flex-direction: column;
`

export default StyledView
